import * as React from 'react';
import invariant from 'invariant';
import { __RouterContext as RouterContext } from 'react-router-dom';

var useRouter = function useRouter() {
  var context = React.useContext(RouterContext);
  invariant(context, "Le contexte de routing est manquant, `@insolus/react-router` est inutilisable sans.\n" + "Veuillez ajouter un `<Router>` (MemoryRouter, BrowserRouter, HashRouter ou Router) englobant.");
  return context;
};

export default useRouter;